import React from "react";

const AboutMeSection = () => {
  return (
    <section className="about-me" id="about">
      <h2 className="section__title section__title--about">Who I Am</h2>

      <div className="about-me__body">
        <p>
          I studied Computer Science at Cornell. I enjoy working across the
          stack — from product features to infrastructure. I'm drawn to
          problems that feel complex but can be solved simply.
        </p>
      </div>
    </section>
  );
};

export default AboutMeSection;
